<template>

    <div class="container">

        <app-head :title="product.meta_title || product.name">
            <meta name="description" :content="product.meta_description" v-if="product.meta_description">
        </app-head>

        <div class="mt-2 mt-lg-5 mb-3">
            <breadcrumbs :items="breadcrumbs" />
        </div>

        <section class="mb-5">

            <div class="row">
                <div class="col-lg-8">

                    <div class="mb-4">
                        <h1 class="h2 mb-3">{{ product.name }}</h1>

                        <div class="d-flex gap-4 small text-nowrap overflow-auto">
                            <div v-if="product.manufacturer">
                                <div>
                                    {{ __('Hersteller') }}
                                </div>
                                <inertia-link :href="route('manufacturers.show', product.manufacturer)" class="text-black-50">
                                    {{ product.manufacturer.short_name || product.manufacturer.name || '-' }}
                                </inertia-link>
                            </div>
                            <div v-if="product.brand">
                                <div>
                                    {{ __('Brand') }}
                                </div>
                                <inertia-link :href="route('brands.show', product.brand)" class="text-black-50">
                                    {{ product.brand.name || '-' }}
                                </inertia-link>
                            </div>
                            <div>
                                <div>
                                    {{ __('Lieferanten-Artikelnr.') }}
                                </div>
                                <span class="text-black-50">
                                    {{ product.supplier_pid || '-' }}
                                </span>
                            </div>
                            <div>
                                <div>
                                    {{ __('Hersteller-Artikelnr.') }}
                                </div>
                                <span class="text-black-50">
                                    {{ product.manufacturer_pid || '-' }}
                                </span>
                            </div>
                            <div>
                                <div class="text-nowrap">
                                    {{ __('Marktplatz-Artikelnr.') }}
                                </div>
                                <span class="text-black-50">
                                    {{ product.sku }}
                                </span>
                            </div>
                            <div>
                                <div>
                                    {{ __('EAN') }}
                                </div>
                                <span class="text-black-50">
                                    {{ product.ean || '-' }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="row my-2 my-lg-5">
                        <div class="col-md-7">

                            <div class="row">
                                <div class="col-10 order-1">
                                    <div class="text-center img-zoom-container">
                                        <img id="myimage" class="img-fluid product-details__image" :src="product.main_image_url" alt="" ref="largeImage" />
                                        <!--<div id="myresult" class="img-zoom-result" ref="largeImageResult"></div>-->
                                    </div>
                                </div>
                                <div class="col-2 order-0">
                                    <div class="d-grid gap-2 mh-100 overflow-auto">
                                        <div class="" v-for="image in images">
                                            <a :href="image.thumbnail_url" class="" @click.prevent="showImage(image.large_url)">
                                                <img class="img-fluid border p-2" :src="image.thumbnail_url" alt="" loading="lazy" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="mt-3 mt-lg-0 col-md-5">

                            <form 
                                id="product-variants"
                                v-if="variantProperties.length">

                                <div class="d-grid gap-3 mb-3">

                                    <div v-for="variantProperty in variantProperties">

                                        <div class="mb-2">
                                            {{ variantProperty.name }}
                                        </div>

                                        <div class="row row-cols-2 g-2">
                                            <div class="col" v-for="propertyOption in variantProperty.propertyOptions">
                                                <input type="radio" 
                                                       @change="selectPropertyOption(propertyOption.id)"
                                                       class="btn-check" 
                                                       :id="'property-option-' + propertyOption.id" 
                                                       autocomplete="off" 
                                                       :value="propertyOption.id" 
                                                       v-model="selectedVariantProperties[variantProperty.id]" />
                                                <label class="btn btn-sm btn-outline-secondary w-100"
                                                       :class="{'foobar': !propertyOption.available}"
                                                       :for="'property-option-' + propertyOption.id">
                                                    <div>
                                                        {{ propertyOption.content }}
                                                    </div>
                                                    <!--                                                    <div v-if="propertyOption.product">
                                                                                                            {{ __('Artikelnr.') }}
                                                                                                            {{ propertyOption.product.supplier_pid }}
                                                                                                        </div>-->
                                                    <!--<price-info :product="variant" />-->
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                    <!--                                    <div class="form-floating">
                                                                            <select class="form-select" id="floatingSelect" v-model="variantForm.variant">
                                                                                <option :value="variant.id" v-for="variant in variants">
                                                                                    {{ variant.name }}
                                                                                    [{{ variant.supplier_pid }}]
                                                                                    {{ variant.optimal_price.price | localizeAmount }}
                                                                                </option>
                                                                            </select>
                                                                            <label for="floatingSelect">{{ __('Variante') }}</label>
                                                                        </div>-->

                                </div>

                            </form>


                        </div>
                    </div>


                    <!--@todo mobile accordion?-->
                    <div class="product-detail-tabs">
                        <ul class="nav nav-pills mb-4 overflow-auto flex-nowrap text-nowrap" id="productTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" href="#description" data-bs-toggle="tab" role="tab" aria-controls="description" aria-selected="true">
                                    {{ __('Beschreibung') }}
                                </a>
                            </li>
                            <li class="nav-item" v-if="product.property_options.length">
                                <a class="nav-link" href="#data" data-bs-toggle="tab" role="tab" aria-controls="data" aria-selected="false">
                                    {{ __('Technische Daten') }}
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#documents" data-bs-toggle="tab" role="tab" aria-controls="documents" aria-selected="false">
                                    {{ __('Dokumente (:count)', {count: totalDocuments}) }}
                                </a>
                            </li>
                            <li class="nav-item"
                                v-if="product.delivery_policy || product.purchase_note || product.refund_policy || product.return_policy">
                                <a class="nav-link" href="#notes" data-bs-toggle="tab" role="tab" aria-controls="notes" aria-selected="false">
                                    {{ __('Hinweise') }}
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content" id="productTabContent">
                            <div class="tab-pane fade show active product__description" 
                                 id="description" 
                                 role="tabpanel" 
                                 aria-labelledby="description-tab"
                                 >
                                <!--@todo xss security-->
                                <div v-if="product.excerpt" v-html="product.excerpt"></div>
                                <div v-html="product.description || product.name"></div>
                            </div>
                            <div class="tab-pane fade" id="data" role="tabpanel" aria-labelledby="data-tab" v-if="product.property_options.length">
                                <table class="table table-bordered table-striped">
                                    <tbody>
                                        <tr v-for="propertyOption in product.property_options">
                                            <th class="w-50 text-muted">{{ propertyOption.property.name }}</th>
                                            <td>{{ propertyOption.content }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="tab-pane fade" id="documents" role="tabpanel" aria-labelledby="documents-tab">
                                <div v-if="documentDefaultContent" v-html="documentDefaultContent">
                                </div>
                                <template v-else>
                                    <ul v-if="documents.length">
                                        <li v-for="attachment in documents">
                                            <a :href="attachment.permalink" target="_blank">
                                                {{ attachment.title }}
                                            </a>
                                            <span class="badge bg-light text-dark" v-if="attachment.mime_type">
                                                {{ attachment.mime_type }}
                                            </span>
                                            <span v-if="attachment.size">
                                                ({{ attachment.size | humanReadableFilesize }})
                                            </span>
                                        </li>
                                    </ul>
                                    <div v-else>
                                        {{ __('Keine Dokumente') }}
                                    </div>
                                </template>
                            </div>
                            <div class="tab-pane fade" id="notes" role="tabpanel" aria-labelledby="notes-tab"
                                 v-if="product.delivery_policy || product.purchase_note || product.refund_policy || product.return_policy">
                                <div v-if="product.delivery_policy">
                                    <b>{{ __('Lieferbedingungen') }}</b>
                                    {{ product.delivery_policy }}
                                </div>
                                <div v-if="product.purchase_note">
                                    <b>{{ __('Kaufhinweis') }}</b>
                                    <!--@todo nur bei kauf per mail senden?-->
                                    {{ product.purchase_note }}
                                </div>
                                <div v-if="product.refund_policy">
                                    <b>{{ __('Rückerstattung') }}</b>
                                    {{ product.refund_policy }}
                                </div>
                                <div v-if="product.return_policy">
                                    <b>{{ __('Rückgabe') }}</b>
                                    {{ product.return_policy }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-lg-4">

                    <div class="mb-3 mt-3 mt-lg-0 sticky-lg-top">
                        <div class="bg-light p-4">
                            <div class="fw-bold">
                                <inertia-link :href="route('suppliers.show', product.supplier)" class='link-dark'>
                                    {{ product.supplier.name }}
                                </inertia-link>
                            </div>
                            <div class="text-muted small">
                                {{ __('Partner') }}
                            </div>
                            <!--                                                    @todo<div class="">
                                                            <span class="text-primary">
                                                                <i class="bi bi-star-fill"></i>
                                                                <i class="bi bi-star-fill"></i>
                                                                <i class="bi bi-star-fill"></i>
                                                                <i class="bi bi-star-fill"></i>
                                                                <i class="bi bi-star-half"></i>
                                                            </span>
                                                            <span>(789)</span>
                                                        </div>-->
                            <div class="my-3">

                                <div v-if="product.default_price">
                                    <div class="h1 m-0">
                                        {{ product.default_price.price | localizeAmount }}
                                    </div>
                                    <s class="" v-if="$page.props.app.theme == 'dentalink'">
                                        {{ product.default_price.price * 1.05 | localizeAmount }} ({{ __('Listenpreis') }})
                                    </s>
                                    <div class="text-black-50 d-flex gap-3">
                                        <!--@todo order_unit/content_unit usw-->
                                        <span v-if="product.content_units_per_order_unit">
                                            {{ __(':count St./Pack.', {count: $options.filters.localizeNumber(product.content_units_per_order_unit) }) }}
                                        </span>
                                        <span v-if="product.default_price.lower_bound">
                                            {{ __(':count Pack.', {count: product.default_price.lower_bound }) }}
                                        </span>
                                    </div>
                                </div>

                                <div 
                                    class="d-flex bg-white p-3 small border mt-3" 
                                    v-if="product.supplier.general_product_price_text" 
                                    >
                                    <div class="fs-3 text-primary me-3">
                                        <i class="bi bi-exclamation-triangle"></i>
                                    </div>
                                    <div v-html="product.supplier.general_product_price_text"></div>
                                </div>

                                <div class="text-black-50" v-if="product.price_hint">
                                    {{ product.price_hint }}
                                </div>

                            </div>

                            <div class="d-flex align-items-center gap-2" v-if="product.hazardous_material">
                                <i class="bi bi-exclamation-triangle-fill text-danger fs-4"></i>
                                {{ __('Gefahrgut') }}
                            </div>

                            <div class="">
                                <table class="product__offers">
                                    <tbody>
                                        <tr v-for="productPrice in product.individual_product_prices" v-if="productPrice.lower_bound > 1">
                                            <th class="w-50 text-muted">{{ __('ab :count Stck.', {count: productPrice.lower_bound}) }}</th>
                                            <td>{{ productPrice.price | localizeAmount }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="d-flex flex-column gap-2 mb-3">
                                <div v-if="product.quantity_min > 1">
                                    <div class="small text-secondary">
                                        {{ __('Mindestbestellmenge') }}
                                    </div>
                                    <div>
                                        {{ product.quantity_min }}
                                    </div>
                                </div>
                                <div v-if="product.quantity_max">
                                    <div class="small text-secondary">
                                        {{ __('Maximalbestellmenge') }}
                                    </div>
                                    <div>
                                        {{ product.quantity_max }}
                                    </div>
                                </div>
                                <!--@todo Wichtig für Kunden?-->
                                <div v-if="product.quantity_interval > 1">
                                    <div class="small text-secondary">
                                        {{ __('Bestellmengenintervall') }}
                                    </div>
                                    <div>
                                        {{ product.quantity_interval }}
                                    </div>
                                </div>
                            </div>

                            <tax-info :product="product" />

                            <delivery-info :product="product" />

                            <div class="small text-muted mt-2">
                                <inertia-link :href="route('suppliers.show', product.supplier)">
                                    {{ __('Für weitere Informationen, Impressum, AGB und Widerrufsrecht klicken Sie bitte hier.') }}
                                </inertia-link>
                            </div>

                            <div class="mt-4" v-if="customerMustHaveRelation && !customerHasRelation">
                                <inertia-link :href="customerMustHaveRelationUrl" class="btn btn-lg btn-outline-dark w-100">
                                    {{ __('Sie sind noch kein Kunde bei diesem Lieferanten.') }}<br>
                                        <b>{{ __('Jetzt freischalten lassen.') }}</b>
                                </inertia-link>
                            </div>
                            <div v-else>
                                <form @submit.prevent="cartForm.post(route('cart.add-item', product))"
                                       v-if="$page.props.auth.user.can.add_cart_items">
                                    <div class="mt-4 row">
                                        <div class="col-xl-5">
                                            <quantity 
                                                v-model.number="cartForm.quantity" 
                                                :min="product.quantity_min"
                                                :max="product.quantity_max"
                                                :interval="product.quantity_interval"
                                                />
                                        </div>
                                        <div class="col-xl-7 mt-3 mt-xl-0">
                                            <button class="btn btn-lg btn-primary text-white w-100"
                                                    type="submit"
                                                    data-bs-toggle="offcanvas@todo"
                                                    data-bs-target="#offcanvasCart"
                                                    aria-controls="offcanvasCart"
                                                    :disabled="cartForm.processing">
                                                <i class="bi bi-cart"></i>
                                                {{ __('In den Warenkorb') }}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>

                        <template v-if="$page.props.app.theme == 'dentalinkTODO'">
                            <div class="bg-dark text-white mb-5 p-4 mt-3 rounded-4" style="">
                                <div class="">
                                    <div class="">
                                        <div class="">
                                            <div>
                                                <img src="/img/dentagen.jpg" alt="DENTAGEN" class="img-fluid border border-white" style="max-width: 160px;" />
                                            </div>
                                            <h3 class="h6 mt-3">
                                                Noch bessere Preise? Jetzt DENTAGEN-Mitglied werden
                                            </h3>
                                            <div class="mt-3">
                                                <a href="https://www.dentagen.de/" class="btn btn-outline-light" target="_blank">
                                                    DENTAGEN-Website aufrufen
                                                </a>    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="mt-4">
                            <div class="row">

                                <div class="col-sm-6">
                                    <template v-if="isOnWatchlist">
                                        <inertia-link :href="route('watchlist.remove-item', product)" as="button" method="delete" class="btn btn-primary w-100 text-white">
                                            <i class="bi bi-pin-angle"></i>
                                            <div class="mt-2">
                                                {{ __('Von Merkliste entfernen') }}
                                            </div>
                                        </inertia-link>
                                    </template>
                                    <template v-else>
                                        <inertia-link :href="route('watchlist.add-item', product)" as="button" method="post" class="btn btn-outline-primary w-100">
                                            <i class="bi bi-pin-angle"></i>
                                            <div class="mt-2">
                                                {{ __('In Merkliste speichern') }}
                                            </div>
                                        </inertia-link>
                                    </template>
                                </div>

                                <div class="col-sm-6" v-if="product.supplier.contact_email">
                                    <!--@todo nachricht an supplier/account/user?-->
                                    <a :href="'mailto:' + product.supplier.contact_email" class="btn btn-outline-primary w-100">
                                        <i class="bi bi-question-square me-2"></i>
                                        <div class="mt-2">
                                            {{ __('Frage zum Produkt') }}
                                        </div>
                                    </a>
                                </div>

                            </div>
                        </div>

                        <!--                 @todo       <div class="card mt-4" v-if="offers.length">
                                                    <div class="card-body">
                                                        <h6 class="card-title">
                                                            {{ __('Andere Verkäufer im DENTAGEN Marktplatz') }}
                                                        </h6>
                                                        <inertia-link :href="route('products.offers', product.sku)" class="stretched-link">
                                                            {{ __(':count Angebot(e)', {count: offers.length}) }} 
                                                            {{ __('ab :price', {price: $options.filters.localizeAmount(lowestPrice)}) }}
                                                        </inertia-link>
                                                    </div>
                                                </div>-->

                    </div>

                </div>
            </div>

        </section>

        <section v-if="linkedProducts.length">
            <heading title="Verwandte Produkte">
            </heading>
            <product-teasers :products="linkedProducts" />
        </section>

        <section v-if="similarProducts.length">
            <heading title="Ähnliche Produkte">
            </heading>
            <product-teasers :products="similarProducts" />
        </section>

        <section>
            <heading title="Angesehene Produkte">
            </heading>
            <visited-products />
        </section>

    </div>

</template>

<script>
    import Heading from '@/shared/Heading';
    import Quantity from '@/shared/Quantity';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import VisitedProducts from '@/shared/VisitedProducts';
    import ProductTeasers from '@/shared/ProductTeasers';
    import PriceInfo from '@/shared/PriceInfo';
    import TaxInfo from '@/shared/TaxInfo';
    import DeliveryInfo from '@/shared/DeliveryInfo';

//    import PicZoom from 'vue-piczoom';

    export default {
        props: [
            'product',
//            'variants',
            'variantProperties',
            'currentPropertyOptions',
            'images',
            'documents',
            'totalDocuments',
            'offers',
            'lowestPrice',
            'similarProducts',
            'linkedProducts',
            'isOnWatchlist',
            'customerMustHaveRelation',
            'customerMustHaveRelationUrl',
            'customerHasRelation',
            'documentDefaultContent',
        ],
        mounted() {

        },
        data() {
            return {
                cartForm: this.$inertia.form({
                    product_id: this.product.id,
                    quantity: this.product.quantity_min || 1,
                }),
                selectedVariantProperties: this.currentPropertyOptions,
            }
        },
        components: {
            Heading,
            Quantity,
            Breadcrumbs,
            VisitedProducts,
            ProductTeasers,
            PriceInfo,
            TaxInfo,
            DeliveryInfo,
//            PicZoom,
        },
        computed: {
            breadcrumbs() {
                var items = [{url: this.route('categories.index'), label: this.__('Categories')}];
                if (this.product.main_category) {
                    items.push({url: this.route('categories.show', this.product.main_category.path), label: this.product.main_category.name});
                }
                return items;
            }
        },
        watch: {
//            selectedVariantProperties: {
//                deep: true,
//                handler: function () {
//                    this.$inertia.post(this.route('products.variant', this.product.parent_id || this.product.id), this.selectedVariantProperties, {preserveState: false})
//                },
//            },
        },
        methods: {
            showImage(src) {
                this.$refs.largeImage.src = src;
            },
            selectPropertyOption(id) {
                var ret = [];
                ret.push(id);
                var foo = this.selectedVariantProperties;
                Object.keys(this.selectedVariantProperties).forEach(function (item) {
                    if (foo[item] !== id) {
                        ret.push(foo[item]);
                    }
                });
//                console.log(ret);

//                let ret = Object.entries(this.selectedVariantProperties).filter(item => {
//                    console.log(item);
////                    return (foo[item] !== id);
//                });

                this.$inertia.post(this.route('products.variant', this.product.parent_id || this.product.id), ret, {preserveState: false})
            }
        }
    }
</script>